import { AllClassifications, RequestState } from './enums';
import { ERequestType } from './ERequestType';

export type RequestsPerType = { [key in ERequestType]: number };
export type RequestsPerClassification = { [key in AllClassifications]: number };
export type RequestsPerAllStatus = { [key in RequestState]: number };

export type RequestsPerCategory = {
    type: RequestsPerType;
    classification: RequestsPerClassification;
    status: RequestsPerAllStatus;
};

export type RequestStatusFilter = 'open' | 'closed' | 'all';

export const allowedStatusMap = {
    open: Object.values(RequestState).filter(
        (state) => ![RequestState.SAVED, RequestState.CLOSED].includes(state as RequestState)
    ),
    closed: [RequestState.CLOSED],
    all: Object.values(RequestState).filter((state) => state !== RequestState.SAVED)
};
